import { render } from "./ValidationMessages.vue?vue&type=template&id=02f0c10e&ts=true"
import script from "./ValidationMessages.vue?vue&type=script&lang=ts"
export * from "./ValidationMessages.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\csit142\\source\\repos\\Website.TorbayDesignGuide\\Website.TorbayDesignGuide.Web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__